import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import pageIndex from '../views/page-index.vue'
// import pageIndex from '../views/maptest.vue'
// import pageIndex from '../views/audio.vue'
import statistics from '../views/statistics.vue'
import forum from '../views/forum.vue'
import knowledge from '../views/knowledge.vue'
import knowledgecourse from '../views/knowledgecourse.vue'
import knowledgesearch from '../views/knowledgesearch.vue'
import perinfo from '../views/perinfo.vue'
import AI from '../views/AI.vue'
// import AI from '../views/stacopy.vue'
import login from '../views/login.vue'

Vue.use(VueRouter)




const routes = [
  {
    path: '/',
    // name: 'home',
    component: HomeView,
    children:[
      {
        path:'/',
        component:pageIndex
    },      {
        path:'statistics',
        component:statistics
    },      {
        path:'forum',
        component:forum
    },   {
        path:'knowledge',
        component:knowledge
    },{
        path:'knowledgesearch',
        component:knowledgesearch
    },{
        path:'knowledgecourse',
        component:knowledgecourse
    },{
        path:'AI',
        component:AI
    },{
        path:'perinfo',
        component:perinfo
    },{
        path:'login',
        component:login
    },
    // ,{
    //   name:'government',
    //     path:'government',
    //     component:government
    // }
    // ,{
    //   name:'industrial',
    //     path:'industrial',
    //     component:industrial
    // }
    // ,{
    //   name:'building',
    //     path:'building',
    //     component:building
    // }
    ]
  },
  // {
  //   path: '/government',
  //   name: 'government',
  //   component: () => import('@/views/governmentnew'),
  //   children:[]
  // },



]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
